<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://zennosys.com/"
        target="_blank"
      >zennosys.com</b-link>
      <span
        class="d-none d-sm-inline-block"
        v-text="$t('app.copyright')"
      />
    </span>
    <span class="float-md-right d-none d-md-block text-primary">Zenno Sys CMS</span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
